/**
 * @generated SignedSource<<05e5abe17cc8dee398e422c62a7ab150>>
 * @relayHash ffc4aede5d787c1ab10609dac8e5c5fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf0e43c38d7bd278ae03ad0f7dab63e31964f7d06ea8058a3c4cada548ccec66

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookTemplatesQuery } from './PlaybookTemplatesQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookTemplatesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bf0e43c38d7bd278ae03ad0f7dab63e31964f7d06ea8058a3c4cada548ccec66",
    "metadata": {},
    "name": "PlaybookTemplatesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
